module.exports = __webpack_public_path__ + "static/About Image 4-e47e76341e635f72baec9373946549bb.jpg";